// src/directives/clickOutside.js
export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function(event) {
      // ここでelementとクリックされた要素が同じでないかを確認
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);  // 引数でバインドされたメソッドを実行
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
};
